import React from 'react'
import { Global as GlobalStyles } from '@creditas/stylitas'
import { cssReset } from './global.style'

const Global = () => <GlobalStyles styles={cssReset} />

Global.displayName = 'Global'

export { Global }
